import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { queryBusinessUnits } from '@/adapters/business-unit';
import { IBusinessUnit } from '@/interfaces/business-unit';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { twMerge } from 'tailwind-merge';

interface IProps {
  value?: number[];
  size?: SizeType;
  handleSelectData: (id: number[]) => void;
  customClassname?: string;
  isAll?: boolean;
  disabled?: boolean;
}

const BusinessUnitMultiSelector = ({
  value,
  size = 'large',
  handleSelectData,
  customClassname,
  isAll,
  disabled = false,
}: IProps) => {
  const [group, setBusinessUnit] = useState<IBusinessUnit[]>([]);
  const mutations = useMutation({
    mutationFn: async () => await queryBusinessUnits(),
    mutationKey: ['fetchBusinessUnit'],
    onSuccess: data => {
      if (data?.status != 200) {
        throw new Error();
      } else {
        setBusinessUnit(data.data);
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const fetchBusinessUnit = async () => {
    try {
      mutations.mutateAsync();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchBusinessUnit();
  }, []);

  const groupOptions =
    group?.map(g => {
      return {
        value: g.id,
        label: g.name,
      };
    }) || [];
  const allOption = {
    value: null,
    label: 'ทั้งหมด',
  };

  return (
    <Select
      allowClear
      mode="multiple"
      value={value}
      className={twMerge('md:min-w-[350px]', customClassname)}
      size={size}
      placeholder="เลือก BU"
      disabled={mutations.isPending || disabled}
      loading={mutations.isPending}
      onChange={handleSelectData}
      options={isAll ? [allOption, ...groupOptions] : groupOptions}
    />
  );
};

export default BusinessUnitMultiSelector;
